export {
  languageMap
} from '@/utils/constants'

export const platformMap = new Map([
  ['tme', '全部平台'],
  ['qq', 'QQ音乐'],
  ['kg', '酷狗音乐'],
  ['kw', '酷我音乐']
])

export const chartPlatFormMap = new Map([
  ['tme', 'TME'],
  ['qq', 'QQ音乐'],
  ['kg', '酷狗'],
  ['kw', '酷我']
])

export const cycleMap = new Map([
  [-9999, '近两年'],
  [-7, '近一周'],
  [-30, '近一月']
])

export const sortMap = new Map([
  ['new', '最新'],
  ['hot', '最热']
])

export const propMap = {
  play: '播放量',
  download: '下载量',
  fav: '收藏量'
}
